import { KeyValue } from "@/main/models/common";
import React, { createContext, useContext, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";

interface ISupervisorRegisterProvider {
	children: React.ReactNode;
}

interface ISupervisorRegisterContext {
	isEdit: boolean;
	setIsEdit: (value: boolean) => void;
}

export interface ISupervisorRegisterForm {
	country: KeyValue | null | undefined;
	name: string;
	rfc: string;
	statusRegister: KeyValue | null;
	insurer: KeyValue | null;
}

const INITIAL_FORM_STATE: ISupervisorRegisterForm = {
	country: null,
	name: "",
	rfc: "",
	statusRegister: null,
	insurer: null,
};

const SupervisorregisterContext = createContext<ISupervisorRegisterContext>({
	isEdit: false,
	setIsEdit: () => {},
});

export function SupervisorRegisterProvider({ children }: ISupervisorRegisterProvider) {
	const methods = useForm<ISupervisorRegisterForm>({
		mode: "onChange",
		defaultValues: INITIAL_FORM_STATE,
	});

	const [isEdit, setIsEdit] = useState(false);

	return (
		<FormProvider {...methods}>
			<SupervisorregisterContext.Provider value={{ isEdit, setIsEdit }}>{children}</SupervisorregisterContext.Provider>
		</FormProvider>
	);
}

export const useSupervisorRegisterContext = () => useContext(SupervisorregisterContext);
